import MobileDetect from 'mobile-detect';

const device = () => new MobileDetect(window.navigator.userAgent);

export { device };
